function hamburgerMenu() {
    // CSS toggle for hamburger menu
  	document.querySelector('.third-button').addEventListener('click', function () {
		document.querySelector('.animated-icon3').classList.toggle('open');
	});
}

export { hamburgerMenu as default };